import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/content';

// 3 + 2 layout on large screens: 6-col grid, each card spans 2, 4th starts at col 2.
const lgPlacement = ['', '', '', 'lg:col-start-2', ''];
export function Bonuses() {
  return <section className="w-full bg-navy px-5 py-20 text-white sm:px-8" data-id="element-16" data-mp="ftmwv7x5b70d">
      <div className="mx-auto w-full max-w-6xl" data-id="element-17" data-mp="1uertyeax4o9">
        <Reveal data-id="element-18" data-mp="1tlu1mxblpi9">
          <h2 className="flex flex-wrap items-center justify-center gap-3 text-center font-display text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-19" data-mp="1t3nnxgy1uwm">
            <GiftIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-20" data-mp="3o24vs3zcw1vd" />
            <span data-id="element-21" data-mp="3o3y21i624k2u">
              You Also Get <span className="text-brand" data-id="element-22" data-mp="3szwov1bqlu15">5 Strategic Bonuses</span>
            </span>
          </h2>
          <p className="mt-4 text-center text-sm font-semibold uppercase tracking-widest text-gold" data-id="element-23" data-mp="1m9ywldfm8wy2">
            Total value $94 — included free
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-6" data-id="element-24" data-mp="3ie6gdcxu9ttk">
          {bonuses.map((bonus, index) => <Reveal key={bonus.tag} delay={index % 3 * 0.05} className={`h-full lg:col-span-2 ${lgPlacement[index]}`} data-id="element-25" data-mp="3dg4zmynvy6l9" data-mpi={index}>
              <article className="flex h-full flex-col overflow-hidden rounded-card border border-white/10 bg-ink" data-id="element-26" data-mp="3n5eqycawnl8b">
                <div className="border-b border-white/10 bg-ink" data-id="element-27" data-mp="2zf2d6kszau9t">
                  <img src={bonus.image} alt={bonus.imageAlt} loading="lazy" className="aspect-square w-full object-cover" data-id="element-28" data-mp="2zhezfa5rrqso" />
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-29" data-mp="33g4c10izh4b9">
                  <div className="flex items-center justify-between gap-3" data-id="element-30" data-mp="nq1bz1drb6th">
                    <span className="text-xs font-bold uppercase tracking-widest text-white/55" data-id="element-31" data-mp="ns4bcc0sucav">
                      {bonus.tag}
                    </span>
                    <span className="rounded-full bg-gold px-3 py-1 text-3xs font-bold uppercase tracking-widest text-navy" data-id="element-32" data-mp="3cjpshb57fgtw">
                      {bonus.value} value
                    </span>
                  </div>
                  <h3 className="mt-3 font-display text-base font-extrabold leading-snug" data-id="element-33" data-mp="3lkw8lj3xypmm">
                    {bonus.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/65" data-id="element-34" data-mp="2tsf3x0mybg56">
                    {bonus.description}
                  </p>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}